/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodetreequeues3Inputs */

const en_entity_contactcodetreequeues3 = /** @type {(inputs: Entity_Contactcodetreequeues3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Tree Queues`)
};

const de_entity_contactcodetreequeues3 = /** @type {(inputs: Entity_Contactcodetreequeues3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Baum-Queues`)
};

/**
* | output |
* | --- |
* | "Contact Code Tree Queues" |
*
* @param {Entity_Contactcodetreequeues3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodetreequeues3 = /** @type {((inputs?: Entity_Contactcodetreequeues3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodetreequeues3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodetreequeues3(inputs)
	return de_entity_contactcodetreequeues3(inputs)
});
export { entity_contactcodetreequeues3 as "entity_contactCodeTreeQueues" }